/**
 * useChatShell -- context that ChatShellLayout hands down to the routed child
 * (ChatPage, SettingsHubPage, ...). Read with useOutletContext so the child
 * does not have to know how the shell is composed.
 */

import type { RefObject } from 'react';
import { useOutletContext } from 'react-router';

export interface ChatShellContext {
  isMobile: boolean;
  isTablet: boolean;
  sidebarOpen: boolean;
  /** True when the sidebar can be hidden and a toggle button must be offered. */
  showSidebarToggle: boolean;
  /** Ref of the visible sidebar toggle button, so the child can restore focus to it. */
  toggleButtonRef: RefObject<HTMLButtonElement | null>;
}

export function useChatShell(): ChatShellContext {
  return useOutletContext<ChatShellContext>();
}
